import { nomineeRow } from '../constants/ActionTypes';

const INITIAL_STATE = {
    list: [],
    selected: null
}

const positionsActionsFunc = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case nomineeRow.GET_NOMINEE_ROWS: {
            return { ...state, list: action.payload }
        }
        case nomineeRow.GET_NOMINEE_ROW: {
            return { ...state, selected: action.payload }
        }
        default:
            return state;
    }
}

export default positionsActionsFunc